import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, RouterNavigatedPayload } from '@ngrx/router-store';
import { UserActions, cancelReport, sendReport } from 'pages-lib';
import { of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';


@Injectable()
export class RouterEffectsEffects {

  clearReports$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATED),
      filter((action: RouterNavigatedPayload) => {
        const url = action?.event?.url;
        return url && (url === '/text-entry' || url === '/auth')
      }),
      switchMap(() => of(cancelReport()))
    );
  });

  navigateHome$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.userLoaded),
      tap(() => {
        this.router.navigate([this.env.homePath]);
      })
    );
  }, { dispatch: false });

  exitOnSignOut$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.signOut),
      tap(() => {
        this.router.navigate(['/auth']);
      })
    );
  }, { dispatch: false });

  navigateToLoadingScreen$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(sendReport),
      tap(() => {
        this.router.navigate(['/text-entry/processing']);
      })
    )
  }, {
    dispatch: false
  });

  constructor(
    private actions$: Actions, 
    private router: Router,
    @Inject('env') private env: any) { }

}
